import migrator from 'schemas/migrator'
import notifyHoneybadger from 'sagas/notifyHoneybadgerSaga'

export default async ({ data: { permalink, legacy } }) => {
  if (legacy) {
    try {
      return await migrator(permalink)
    } catch (err) {
      notifyHoneybadger({ err, project: permalink, action: { type: 'MIGRATING_PERMALINK' } })
      return null
    }
  } else return permalink
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/handlePermalink.js